import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { DisableDefinitionsMenu } from '../../v2/definitions/body/disable-menu/DisableDefinitionMenu';

import { ReadingAidsMenuButton } from './reading-aids-menu-button';
import { ReadingAidsOptionsWrapper } from './styled';

export const ReadingAidsOptions = () => {
	const platformDisableOn = fg('kd_definitions_confluence_enable_platform');

	return (
		<ReadingAidsOptionsWrapper>
			{platformDisableOn ? <DisableDefinitionsMenu /> : <ReadingAidsMenuButton />}
		</ReadingAidsOptionsWrapper>
	);
};
